module.exports = __webpack_public_path__ + "static/media/6.eb5e1d5f.png";